
export default {
  state:{
    newFile: null,
    urlFile: null,
  },

  
  mutations: {

    setDocAs400( state, data) {
      state.newFile = data.newFile
      state.urlFile = data.urlFile        
    },

    resetDocAs400( state ) {
      state.docAs400 = null
    }
  }
}
  